import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  selectAll() {
    this.checkboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = true
        checkbox.dispatchEvent(new Event("change", {bubbles: true}))
      }
    })
  }

  selectNone() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event("change", {bubbles: true}))
    })
  }

  get checkboxes() {
    return this.element.querySelectorAll('input[type="checkbox"]')
  }
}
